import { Box, Card, styled } from '@mui/material';

export const BlogsContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '10px',
  fontSize: '14px',
  overflow: 'auto',
  [theme.breakpoints.down(1000)]: {
    padding: '0px',
  },
}));

export const CardForBlogsStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  minHeight: '107px',
  backgroundColor: '#ehite',
  boxShadow: 'unset',
  borderRadius: '8px',
  padding: '15px',
  display: 'flex',
  marginBottom: '10px',
  flexDirection: 'column',
  height: '96px',

  '&:hover': {
    backgroundColor: '#F5F6F6',
  },

  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    maxHeight: '343px',
  },
}));
